import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux';
import DataTable from 'react-data-table-component';
import {useLocation, useNavigate} from "react-router-dom";
import {get_budget_surrender} from "../../helper/Api";
import {AiOutlineEye} from 'react-icons/ai';
import {Link} from 'react-router-dom';
import { Card, CardContent, Chip } from '@mui/material';

export default function BudgetSurrender(filterData) {
    const {authData} = useSelector((state) => state.authData);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    let {state} = useLocation();
    const [data, setData] = useState(state && state.data ? state.data : []);

    const customStyles = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    };

    const columns = [
        {
            name: 'View',
            selector: (row) => <Link to={`/view-budget-surrender/${row.batch_id}`} className="btn btn-primary"><AiOutlineEye/></Link>,
            wrap: true,
            width: "100px",
            center: true
        },
        {
            name: 'Order No',
            selector: (row) => row.order_no,
            wrap: true,
            width: "100px"
        },
        {
            name: 'Order Date',
            selector: (row) => row.order_date,
            wrap: true,
            width: "150px"
        },
        {
            name: 'Dept Name',
            selector: (row) => row.department_name,
            wrap: true,
            width: "150px"
        },
        {
            name: 'Dept Level',
            selector: (row) => row.department_level,
            wrap: true,
            width: "150px"
        },
        {
            name: 'Financial Year',
            selector: (row) => row.start_year+'-'+row.end_year,
            wrap: true,
            width: "150px"
        },
        {
            name: 'Scheme Code',
            selector: (row) => row.scheme_code,
            wrap: true,
            width: "150px"
        },
        {
            name: 'Scheme Name',
            selector: (row) => row.name,
            wrap: true,
            width: "300px"
        },
        {
            name: 'Amount',
            selector: (row) => row.order_value,
            wrap: true,
            width: "100px"
        },
        {
            name: 'Status L2',
            selector: (row) => row.l2_approval == null ? <Chip label="Pending" color="warning" size="small" /> : row.l2_approval == 1 ? <Chip label="Approved" color="success" size="small" /> : <Chip label="Rejected" color="error" size="small" />,
            wrap: true,
            width: "100px"
        },
        {
            name: 'Status L3',
            selector: (row) => row.l3_approval == null ? <Chip label="Pending" color="warning" size="small" /> : row.l3_approval == 1 ? <Chip label="Approved" color="success" size="small" /> : <Chip label="Rejected" color="error" size="small" />,
            wrap: true,
            width: "100px"
        },
    ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1); // Reset to the first page when rows per page changes
    };

    const fetchChallans = async () => {
        try {
            let params = {
                department_id: filterData.department_id,
            }
            if(filterData.pending && filterData.pending == true) {
                params.pending = true;
            }
            if(filterData.approved && filterData.approved == true) {
                params.approval = true;
            }
            const resp = await get_budget_surrender(params);
            if (resp.data.status) {
                setData(resp.data.result);
            }
        } catch (error) {
            setData([]);
        }
    }
    // console.log('fdate', filterData.fromDate);
    useEffect(() => {
        fetchChallans();
    }, [filterData.fromDate, filterData.toDate, filterData.dateColumn, filterData.searchStr, filterData.department_id]);

    return (
        <div>
            
            <Card>
                <CardContent>
                    <DataTable
                        customStyles={customStyles}
                        className="dataTables_wrapper"
                        columns={columns}
                        data={data}
                        fixedHeader
                        fixedHeaderScrollHeight="600px"
                        pagination
                        paginationPerPage={rowsPerPage}
                        paginationTotalRows={data.length}
                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                </CardContent>
            </Card>
            
        </div>
    )

}